"use strict";

require("@patsnap-ui/icon/assets/HelpCenter.svg");
require("@patsnap-ui/icon/assets/Products.svg");
require("@patsnap-ui/icon/assets/solid/HelpCentre.svg");
require("@patsnap-ui/icon/assets/solid/SearchLeft.svg");
require("@patsnap-ui/icon/assets/solid/TextFile.svg");
require("@patsnap-ui/icon/assets/solid/conversation.svg");
require("@patsnap-ui/icon/assets/solid/global.svg");
require("@patsnap-ui/icon/assets/solid/Calendar7.svg");
require("@patsnap-ui/icon/assets/solid/ChartHeatmap.svg");
require("@patsnap-ui/icon/assets/Timer.svg");
require("@patsnap-ui/icon/assets/TimerS.svg");
require("@patsnap-ui/icon/assets/solid/VideoExist.svg");
require("@patsnap-ui/icon/assets/Term.svg");
require("@patsnap-ui/icon/assets/Privacy.svg");
require("@patsnap-ui/icon/assets/solid/ArrowTailRight.svg");